



























































































































































































































































































import Vue from "vue";
import tenantService from "@/services/tenantService";

export default Vue.extend({
  name: "PresentationByomDongle",
  computed: {
    isMainTenant(): boolean {
      return tenantService.isMainTenant();
    },
  },
});
